export function useCrypt() {
  const decryptBase64 = (value: string | undefined): string | undefined => {
    if (!value) {
      return undefined;
    }

    return atob(value ?? '');
  };

  return {
    decryptBase64,
  };
}
